import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar } from '@/store/slices/sidebarSlice.js';
import { X, Menu } from 'lucide-react';
import Button from '@/shared/components/elements/Button';
import PropTypes from 'prop-types';

const withSidebarToggle = (WrappedComponent) => {
  const SidebarToggleHOC = (props) => {
    const isCollapsed = useSelector((state) => state.sidebar.isCollapsed);
    const dispatch = useDispatch();

    const handleToggleSidebar = () => {
      dispatch(toggleSidebar());
    };

    // Toggle Button Component
    const ToggleButton = ({ position = 'logo-opposite' }) => {
      if (position === 'logo-opposite' && !isCollapsed) {
        return (
          <div className="absolute top-1/2 left-4 -translate-y-1/2 transform">
            <Button
              onClick={handleToggleSidebar}
              variant="ghost"
              size="sm"
              className="h-7 w-7 p-0"
              aria-label="بستن منو"
              icon={
                <X
                  size={16}
                  className="text-tertiary-80 transition-colors dark:text-gray-400"
                />
              }
              iconPosition="center"
            />
          </div>
        );
      }

      // Toggle button menu burger
      if (position === 'collapsed-center' && isCollapsed) {
        return (
          <div className="flex justify-center pb-4">
            <Button
              onClick={handleToggleSidebar}
              variant="ghost"
              size="sm"
              className="h-7 w-7 p-0"
              aria-label="باز کردن منو"
              icon={
                <Menu
                  size={20}
                  className="text-tertiary-80 transition-colors dark:text-gray-400"
                />
              }
              iconPosition="center"
            />
          </div>
        );
      }

      return null;
    };

    ToggleButton.propTypes = {
      position: PropTypes.oneOf(['logo-opposite', 'collapsed-center']),
    };

    return (
      <WrappedComponent
        {...props}
        isCollapsed={isCollapsed}
        toggleSidebar={handleToggleSidebar}
        ToggleButton={ToggleButton}
      />
    );
  };

  SidebarToggleHOC.displayName = `withSidebarToggle(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return SidebarToggleHOC;
};

export default withSidebarToggle;
